import request from '@/utils/request'

// 课程知识点相关接口
export function getKnowledgeByCourse(courseId) {
  return request({
    url: `/knowledge-points/byCourse/${courseId}`,
    method: 'get'
  })
}

// 获取课程知识点的树形结构（包含子知识点）
export function getKnowledgeTreeByCourse(courseId) {
  return request({
    url: `/knowledge-points/byCourse/${courseId}`,
    method: 'get'
  })
}

export function getKnowledgeByChapter(chapterId) {
  return request({
    url: `/knowledge-points/byChapter/${chapterId}`,
    method: 'get'
  })
}

export function createKnowledge(data) {
  return request({
    url: '/knowledge-points',
    method: 'post',
    data
  })
}

export function updateKnowledge(id, data) {
  return request({
    url: `/knowledge-points/${id}`,
    method: 'put',
    data
  })
}

export function deleteKnowledge(id) {
  return request({
    url: `/knowledge-points/${id}`,
    method: 'delete'
  })
}

// 子知识点管理相关接口
export function getChildrenByParentId(parentId) {
  return request({
    url: `/knowledge-point-relations/children/${parentId}`,
    method: 'get'
  })
}

export function addChildKnowledgePoint(parentId, childId, relationType = 1) {
  return request({
    url: '/knowledge-point-relations/add-child',
    method: 'post',
    params: { parentId, childId, relationType }
  })
}

export function removeChildKnowledgePoint(parentId, childId) {
  return request({
    url: '/knowledge-point-relations/remove-child',
    method: 'delete',
    params: { parentId, childId }
  })
}

export function updateChildSortOrder(parentId, childId, sortOrder) {
  return request({
    url: '/knowledge-point-relations/update-sort',
    method: 'put',
    params: { parentId, childId, sortOrder }
  })
}

export function getKnowledgeOptions(params) {
  return request({
    url: '/knowledge/getContent',
    method: 'get',
    params
  })
}

// 分页查询知识点
export function pageKnowledgePoints(pageNum, pageSize, subject) {
  return request({
    url: '/knowledge/points/page',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      subject
    }
  })
}

// 添加知识点
export function addKnowledgePoint(data) {
  return request({
    url: '/knowledge/points/add',
    method: 'post',
    data
  })
}

// 更新知识点
export function updateKnowledgePoint(data) {
  return request({
    url: '/knowledge/points/update',
    method: 'put',
    data
  })
}

// 删除知识点
export function deleteKnowledgePoint(id) {
  return request({
    url: `/knowledge/points/${id}`,
    method: 'delete'
  })
}

// 批量删除知识点
export function batchDeleteKnowledgePoints(ids) {
  return request({
    url: `/knowledge/points/batch/${ids}`,
    method: 'delete'
  })
}

// 根据ID获取知识点
export function getKnowledgePointById(id) {
  return request({
    url: `/knowledge/points/${id}`,
    method: 'get'
  })
}
export function getKnowledge(params) {
  return request({
    url: '/knowledge/points',
    method: 'get',
    params
  })
}

// 导入知识点Excel文件
export function importKnowledgePoints(formData) {
  return request({
    url: '/knowledge/points/import',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

// 根据学科选项获取知识内容
export function getKnowledgeBySuboptions(suboptions) {
  return request({
    url: '/knowledge/getBySuboptions',
    method: 'get',
    params: {
      suboptions
    }
  })
}

// ==================== 通用知识点接口 ====================

// 查询顶层知识点（parentId=0）
export function listTopKnowledge(repoId) {
  return request({
    url: '/general-knowledge/top',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 按父级ID查询子知识点
export function listKnowledgeByParent(parentId) {
  return request({
    url: `/general-knowledge/parent/${parentId}`,
    method: 'get'
  })
}

// 获取知识点做题进度统计
export function getKnowledgeProgressByRepoId(repoId) {
  return request({
    url: `/general-knowledge/progress/${repoId}`,
    method: 'get'
  })
}

// 按内容+父ID查询知识点
export function getGeneralKnowledgeByContent(content, parentId = 0, repoId, courseType) {
  return request({
    url: '/general-knowledge',
    method: 'get',
    params: {
      content,
      parentId,
      ...(repoId ? { repoId } : {}),
      ...(courseType ? { courseType } : {})
    }
  })
}

// 批量确保父/子知识点存在
// pairs模式: [{parent, child}] 旧模式
// hierarchies模式: ["代数-分数计算"] 新模式，后端按-分隔每一级创建独立记录
export function batchEnsureGeneralKnowledge(pairs, options = { normalize: true, deduplicate: true, upsert: true }, repoId, courseType, hierarchies) {
  return request({
    url: '/general-knowledge/batchEnsure',
    method: 'post',
    data: {
      ...(pairs ? { pairs } : {}),
      ...(hierarchies ? { hierarchies } : {}),
      options,
      ...(repoId ? { repoId } : {}),
      ...(courseType ? { courseType } : {})
    }
  })
}

// 新增知识点
export function createGeneralKnowledge(data) {
  return request({
    url: '/general-knowledge',
    method: 'post',
    data
  })
}

// 根据ID查询知识点
export function getGeneralKnowledgeById(id) {
  return request({
    url: `/general-knowledge/${id}`,
    method: 'get'
  })
}

// 批量获取知识点名称
export function batchGetGeneralKnowledgeNames(ids) {
  return request({
    url: '/general-knowledge/batch-names',
    method: 'post',
    data: { ids }
  })
}

// 查询全部通用知识点（支持 repoId 过滤）
export function listAllGeneralKnowledge(repoId) {
  return request({
    url: '/general-knowledge',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 查询完整知识点树（含所有层级子节点，后端已组装 children）
export function listGeneralKnowledgeTree(repoId) {
  return request({
    url: '/general-knowledge/tree',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 获取知识点统计信息（包含年份统计）
export function getGeneralKnowledgeStats(repoId) {
  return request({
    url: '/general-knowledge/progress/' + (repoId || 0),
    method: 'get'
  })
}

export function migrateSplitGeneralKnowledgeContent(repoId, dryRun = true) {
  const params = {
    dryRun: dryRun ? 'true' : 'false'
  }
  if (repoId != null && repoId !== '') {
    params.repoId = repoId
  }
  return request({
    url: '/general-knowledge/migrate/split-content',
    method: 'post',
    params
  })
}

// 一键清除所有知识点
export function clearAllGeneralKnowledge(repoId, courseType) {
  const params = {}
  if (repoId != null && repoId !== '') {
    params.repoId = repoId
  }
  if (courseType != null && courseType !== '') {
    params.courseType = courseType
  }
  return request({
    url: '/general-knowledge/clear-all',
    method: 'delete',
    params
  })
}

// 从题目knowledge字段批量导入知识点
export function importKnowledgeFromQuestions(knowledges, repoId, courseType) {
  return request({
    url: '/general-knowledge/import-from-questions',
    method: 'post',
    data: {
      knowledges,
      ...(repoId ? { repoId } : {}),
      ...(courseType ? { courseType } : {})
    }
  })
}

// 批量确保多层级知识点（支持 - 分隔的层级结构）
export function batchEnsureHierarchicalKnowledge(hierarchies, options = { normalize: true, deduplicate: true, upsert: true }, repoId, courseType) {
  return request({
    url: '/general-knowledge/batchEnsure',
    method: 'post',
    data: {
      hierarchies,
      options,
      ...(repoId ? { repoId } : {}),
      ...(courseType ? { courseType } : {})
    }
  })
}
